import { Link } from 'react-router-dom';
import {
  Card,
  CardButton,
  Content,
  Heading,
  Inline,
  InlineItem,
  Secondary,
} from '@kinesis/bungle';
import { GHGProtocolIcon } from '@/components/ghg-protocol-icon';
import { gpcPath } from '@/links';

// A synthetic, non-deletable entry for the *legacy* GPC report — the parked,
// hand-entered POC, preserved not migrated. Rendered by `DisclosuresList` when
// the inventory has one (`legacyGpcExists`); clicking it navigates to the
// untouched `pages/gpc` (pure nav). The legacy report is stored, hand-entered
// numbers — not a ledger-computed disclosure — which is why it is preserved and
// linked rather than converted into a deletable disclosure row (a delete would
// lose real prod data). No CardMenu / delete, and it is not a real `Disclosure`
// so it never enters the search index.
const LegacyGpcItem = (props: LegacyGpcItemProps) => {
  const { inventoryId } = props;
  return (
    <Content borderRadiusSize='small'>
      <Card>
        <CardButton as={Link} to={gpcPath(inventoryId)}>
          <Content padding='medium' paddingMode='equal'>
            <Inline space='medium'>
              <InlineItem>
                <GHGProtocolIcon />
              </InlineItem>
              <InlineItem ellipsify>
                <Heading as='h3' size='medium'>
                  GPC report
                </Heading>
                <Secondary>Legacy report</Secondary>
              </InlineItem>
            </Inline>
          </Content>
        </CardButton>
      </Card>
    </Content>
  );
};

export type LegacyGpcItemProps = {
  inventoryId: number;
};

export { LegacyGpcItem };
